"use client";

import React from 'react';
import { useMediaQuery } from "react-responsive";
import { useTranslation } from 'react-i18next';
import HeroDesktop from './Desktop/HeroDesktop';
import HeroMobile from './Mobile/HeroMobile';

const Hero = () => {
  const { t } = useTranslation('translation');
  const isMobile = useMediaQuery({ maxWidth: 768 });
  
  const heroTitle = t("heroTitle");
  const heroDescription = t("heroDescription");
  const typewriterTexts = [
    t("heroTypewriter1"),
    t("heroTypewriter2"),
    t("heroTypewriter3"),
    t("heroTypewriter4"),
    t("heroTypewriter5")
  ];

  return (
    <section
      id="home"
      className="relative z-10 overflow-hidden bg-white pb-16 pt-[60px] dark:bg-gray-dark md:pb-[120px] md:pt-[90px] xl:pb-[160px] xl:pt-[100px] 2xl:pb-[200px] 2xl:pt-[110px]"
    >
      {isMobile ? (
        <HeroMobile 
          heroTitle={heroTitle} 
          typewriterTexts={typewriterTexts} 
          heroDescription={heroDescription} 
        />
      ) : (
        <HeroDesktop 
          heroTitle={heroTitle} 
          typewriterTexts={typewriterTexts} 
          heroDescription={heroDescription} 
        />
      )}
    </section>
  );
};

export default Hero;
